<template>

  <div>
    <v-toolbar flat>
      <v-toolbar-title class="headline font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>

        <v-btn :loading="loading" :disabled="loading" slot="activator" color="info" icon round title="Inserir um novo registro">
          <v-icon>add</v-icon>
        </v-btn>

        <v-card>
          <v-toolbar color="white" class="elevation-3">
            <v-toolbar-items>
              <v-btn @click="initialize();" color="error" icon round flat>
                <v-icon large>remove</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-title class="headline font-weight-light">{{ formTitle }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout wrap row>
                <v-flex xs12>
                  <v-text-field v-model="groupEdit.description" label="Descrição"></v-text-field>
                </v-flex>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <img :src="imageUrl" height="150" v-if="imageUrl" />
                  <v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
                  <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn color="success lighten-1" block round @click="save();">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table rows-per-page-text="Colunas por página" :loading="loading" :headers="headers" :items="groups" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn :disabled="loading" @click="edit(props.item)" title="Editar registro" color="info" round flat icon>
            <v-icon color="info">edit</v-icon>
          </v-btn>

          <v-btn :disabled="loading" @click="groupRemove = props.item; dialogRemove = true;" title="Excluir registro"
            color="error" round flat icon>
            <v-icon color="error">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="footer" v-if="records > 0">
        <td colspan="100%">
          <strong> {{ footerText }} {{ records }} </strong>
        </td>
      </template>

      <template slot="no-data" v-else>
        <strong> {{ emptyRecordsText }} </strong>
      </template>

      <template slot="pageText" slot-scope="props" class="font-weight-light">
        Linhas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog persistent v-model="dialogRemove" max-width="500">
        <v-card>
          <v-toolbar color="white" class="elevation-3" card>
            <v-toolbar-items>
              <v-btn color="error" title="Cancelar" flat round icon>
                <v-icon large>remove</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-title class="headline font-weight-light">Excluir Registro</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <span>Descrição: {{ groupRemove.description }}</span>
          </v-card-text>

          <v-card-actions>
            <v-btn class="font-weight-light" color="success lighten-1" round block @click="remove();">
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>

</template>

<script>
  import GroupService from '../service/GroupService';


  export default {


    data: () => ({
      //Visual
      loading: false,
      ////////
      title: "Listagem de Grupo",
      footerText: "Total de registos: ",
      loadingRecordsText: "Carregando registros...",
      emptyRecordsText: "Nenhum registro encontrado",
      dialog: false,
      dialogRemove: false,
      confirmedExclusion: false,
      isEditing: false,
      records: 0,
      groupRemove: {},
      groupEdit: {},
      groups: [],
      group: {},
      imageName: '',
      imageUrl: '',
      imageFile: '',
      headers: [{
          text: 'Descrição',
          align: "center",
          value: 'description'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'description',
          sortable: false
        }
      ],
    }),

    computed: {
      formTitle() {
        return this.isEditing ? 'Editar Grupo' : 'Criar Grupo'
      },
      dynamicFooterText() {
        let text = `${this.loading ? this.loadingRecordsText : this.emptyRecordsText}`
        return text
      }
    },

    watch: {
      dialog(val) {
        val || this.initialize();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      calculateRecords() {
        let amount = 0;
        this.groups.forEach(element => {
          amount++;
        });
        this.records = amount;
      },

      async initialize() {
        this.loading = true;
        try {
          this.groups = await GroupService.getAll();
          this.calculateRecords();
          this.isEditing = false;
          this.dialog = false;
          this.dialogRemove = false;
          this.group = {};
          this.groupEdit = {};
          this.groupRemove = {};
          this.confirmedExclusion = false;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },

      edit(groupEditing) {
        this.groupEdit = groupEditing;
        this.isEditing = true;
        this.disabledButtonSave = false;
        this.dialog = true;
      },

      async remove() {
        await GroupService.remove(this.groupRemove);
        this.initialize();
      },

      async save() {
        this.loading = true;
        this.group = this.groupEdit;
        try {
          if (this.isEditing) {
            await GroupService.update(this.group);
          } else {
            await GroupService.save(this.group);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
          this.initialize();
          this.clear();
        }



      }, // save()

      pickFile() {
        this.$refs.image.click()
      },

      onFilePicked(e) {
        const files = e.target.files
        if (files[0] !== undefined) {
          this.imageName = files[0].name
          if (this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.imageUrl = fr.result
            this.imageFile = files[0] // this is an image file that can be sent to server...
          })
        } else {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
        }
      },
      async clear() {
        this.group = {}
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Group.vue